import GenericCard from "widgets/cards/generic";
import { SecondaryHeightLayout } from "hooks/viewport-dimensions";
import { createAccount } from "api/account";
import AccountAddForm from "widgets/forms/support/accountAdd";
import { AccountAddBody } from "api/types/account";
import { setLoading } from "store/appSlice";
import { notifySimple } from "providers/toast";
import { useTranslation } from "react-i18next";

const AccountManagement = () => {
  const { t } = useTranslation();

  const onSubmit = async (formData: any) => {
    try {
      setLoading(true);
      const { status, isLoading } = await createAccount(
        formData as AccountAddBody
      );
      setLoading(isLoading);
      if (status && status === 200) {
        notifySimple(t("notification.account.created"), "success");
      } else {
        notifySimple(t("notification.account.not.added"), "error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <SecondaryHeightLayout>
      <GenericCard extra="h-full">
        <div className={`flex h-full flex-col gap-2`}>
          <AccountAddForm submit={onSubmit} />
        </div>
      </GenericCard>
    </SecondaryHeightLayout>
  );
};

export default AccountManagement;
